import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as thunks from 'features/thunks'
import Category from './category-model'
import {
  CreateCategoryAsync,
  DeleteCategoryAsync,
  LoadCategorysAsync,
} from './category-thunk'
const initialState: categorySliceState = {
  category: [],
  selected_category: '',
  is_loading_category: false,
  is_creating_category: false,
  is_deleting_category: false,
}
export interface categorySliceState {
  category: Category[]
  selected_category?: string
  is_loading_category: boolean
  is_creating_category: boolean
  is_deleting_category: boolean
}
export const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setSelectedcategory: (state, action) => {
      state.selected_category = action.payload
    },
    clearStatecategory: (state) => {
      state.category = []
      state.is_loading_category = false
      state.is_creating_category = false
      state.is_deleting_category = false
    },
    mergecategory: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_category = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.category = merge(state.category, payload) as any
        }
      }
    },

    add_category: (state, action) => {
      if (action.payload) {
        state.category = [...state.category, action.payload]
      }
    },
    set_category: (state, action) => {
      let { key, value, id } = action.payload
      state.category = state.category.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(thunks.AddCategoryAsync.pending, (state) => {
      state.is_loading_category = true
    })
    builder.addCase(thunks.AddCategoryAsync.fulfilled, (state, action) => {
      state.is_loading_category = false
      handleResult(action, state)
    })
    builder.addCase(thunks.AddCategoryAsync.rejected, (state) => {
      state.is_loading_category = false
    })

    builder.addCase(thunks.UpdateCategoryAsync.pending, (state) => {
      state.is_loading_category = true
    })
    builder.addCase(thunks.UpdateCategoryAsync.fulfilled, (state, action) => {
      state.is_loading_category = false
      handleResult(action, state)
    })
    builder.addCase(thunks.UpdateCategoryAsync.rejected, (state) => {
      state.is_loading_category = false
    })

    builder.addCase(thunks.DeleteCategoryAsync.pending, (state) => {
      state.is_loading_category = true
    })
    builder.addCase(thunks.DeleteCategoryAsync.fulfilled, (state, action) => {
      state.is_loading_category = false
      handleResult(action, state)
    })
    builder.addCase(thunks.DeleteCategoryAsync.rejected, (state) => {
      state.is_loading_category = false
    })

    builder.addCase(thunks.GetCategoryByNameAsync.pending, (state) => {
      state.is_loading_category = true
    })
    builder.addCase(
      thunks.GetCategoryByNameAsync.fulfilled,
      (state, action) => {
        state.is_loading_category = false
        handleResult(action, state)
      },
    )
    builder.addCase(thunks.GetCategoryByNameAsync.rejected, (state) => {
      state.is_loading_category = false
    })

    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCategorysAsync.pending, (state) => {
      state.is_loading_category = true
    })
    builder.addCase(LoadCategorysAsync.fulfilled, (state, action) => {
      state.is_loading_category = false
      if (action.payload) {
        state.category = action.payload
      }
    })
    builder.addCase(LoadCategorysAsync.rejected, (state) => {
      state.is_loading_category = false
    })
    builder.addCase(CreateCategoryAsync.pending, (state) => {
      state.is_creating_category = true
    })
    builder.addCase(CreateCategoryAsync.fulfilled, (state) => {
      state.is_creating_category = false
    })
    builder.addCase(CreateCategoryAsync.rejected, (state) => {
      state.is_creating_category = false
    })
    builder.addCase(DeleteCategoryAsync.pending, (state) => {
      state.is_deleting_category = true
    })
    builder.addCase(DeleteCategoryAsync.fulfilled, (state, action) => {
      state.is_deleting_category = false
      if (state.category) {
        state.category = state.category.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteCategoryAsync.rejected, (state) => {
      state.is_deleting_category = false
    })
  },
})

function handleResult(action: any, state: categorySliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_category = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.category = merge(state.category, payload) as any
    }
  }
}

export const {
  clearStatecategory,
  setSelectedcategory,
  set_category,
  mergecategory,
  add_category,
} = categorySlice.actions

export const get_category =
  (id?: string) =>
  (state: {
    category: {
      category: Category[]
    }
  }): Category | null => {
    let temp = state?.category?.category?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.category?.category[0] || null
  }
export const get_selected_category = (state: {
  category: categorySliceState
}): Category | null => {
  let id = state?.category?.selected_category
  let temp = state?.category?.category?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_category = (state: {
  category: {
    category: Category[]
  }
}): Category[] => {
  let temp = state?.category?.category
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_category_busy = (state: { category: categorySliceState }) => {
  return (
    state?.category.is_deleting_category ||
    state?.category.is_loading_category ||
    state?.category.is_creating_category
  )
}
export const is_deleting_category_busy = (state: {
  category: categorySliceState
}) => {
  return state?.category.is_deleting_category
}
export const is_loading_category_busy = (state: {
  category: categorySliceState
}) => {
  return state?.category.is_loading_category
}
export const is_creating_category_busy = (state: {
  category: categorySliceState
}) => {
  return state?.category.is_creating_category
}

export default categorySlice.reducer
